import { render } from "./AddTitleView.vue?vue&type=template&id=0731132c"
import script from "./AddTitleView.vue?vue&type=script&lang=js"
export * from "./AddTitleView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__